import { injectable } from 'inversify'
import type { ITelemetryService } from '@/services/telemetry/types'

@injectable()
export class NoopTelemetryService implements ITelemetryService {
  public init() {
    // Do nothing
  }
}
